module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontmatter",
    attrs: {
      "id": "illustrations"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h3', [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Section0006"
    }
  }, [_vm._v("I arose in haste and, drawing the sword from under his head, dealt him a blow that made his head fall from his body. . . . Then she drew a sword . . . and threw herself thereon . . . and she fell to the ground dead")]), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("While they were thus enjoying themselves, lo! up came a damsel, trembling for fear and said, ‘O my Lady! The Commander of the Faithful’s eunuchs are at the door’")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0